<script></script>

<div id="title">
  <div class="title--title add-arrow">
    <h1>Giorgia Meloni<br />VS<br />Elly Schlein</h1>
  </div>
</div>

<style>
  #title {
    display: block;
    margin: 0;
    position: relative;
    width: auto;
  }

  .title--title {
    align-items: center;
    background-size: contain;
    display: flex;
    height: 80vh;
    justify-content: center;
    margin: 0;
    padding: 20px 40px;
    position: relative;
    top: 0;
  }

  h1 {
    font-size: 42px;
    font-weight: 900;
    letter-spacing: .005rem;
    line-height: 1;
    text-align: center;
    text-shadow: 2px 2px 0 var(--light);
    text-transform: uppercase;
  }

  @media screen and (min-width:768px) {
    #title {
      margin: 0 auto;
      max-width: 960px;
    }

    h1 {
      font-size: 54px;
    }
  }
  
  @media screen and (min-width:1280px) {
    .title--title {
      padding: 40px 0;
    }

    h1 {
      font-size: 78px;
    }
  }
</style>